import React from 'react';
// components
import AgentActivity, { affectRerenderKeys } from './AgentActivity/AgentActivity';
// hoc
import withActivityController from './hoc/withActivityController';

// EveryPig Agent workflow #1: withdrawal warning at 170 lbs
const AgentWithdrawalWarningActivity = (props) => (
  <AgentActivity
    {...props}
    titleId="component.agentWithdrawalWarningActivity.title"
    textId="component.agentWithdrawalWarningActivity.text"
  />
);

export default withActivityController(AgentWithdrawalWarningActivity, { affectRerenderKeys });
